<template>
  <div>
    <el-table
      :header-cell-style="{backgroundColor:'rgb(84, 92, 100)',color:'#f9f9f9'}"
      v-loading="this.$store.state.tableLoading[this.lv]"
      ref="multipleTable"
      :data="datas"
      border
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <el-table-column
        v-if="showSelected"
        fixed="left"
        type="selection"
        width="50">
      </el-table-column>
      <template v-for="item in labels">
        <el-table-column
          :show-overflow-tooltip="true"
          :prop="item.prop"
          :label="item.label"
          :width="item.width || 'auto'">
          <template slot-scope="scope">
            {{chooseFilter(item.prop,scope.row[item.prop],item.map,item.dateFomatter)}}
          </template>
        </el-table-column>
      </template>
      <el-table-column
        v-if="opts&&opts.length"
        fixed="right"
        label="操作"
        :width="opts.length*50">
        <template slot-scope="scope">
          <template v-for="item in opts">
            <el-button @click="item.fn(scope.row)" :disabled="item.dis?item.dis.indexOf(scope.row[item.disprop])>=0:false" type="text" size="small" v-html="item.mapChar?item.map[scope.row[item.mapChar]]:(item.filterChar?item.filterFn(scope.row[item.filterChar]):item.label)"></el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  export default{
    name: 'smart-table',
    props: ['table-label', 'table-data', 'table-opt','show-select','level'],
    data() {
      return {
        labels: this.tableLabel,
        datas: this.tableData,
        opts: this.tableOpt,
        showSelected:this.showSelect || false,
        lv:this.level || 1

      }
    },
    methods:{
      chooseFilter(prop,val,map,dateFomatter){
          if(dateFomatter){
              return val ? new Date(val).pattern(dateFomatter) : '-'
          }
          if(map){
              return map[val]||"";
          }

          if(prop == 'date'){
            return val ? new Date(val).pattern("yyyy-MM-dd") : '-'
          }
          if(prop == 'czdate' || prop == 'createAt'){
            var date =  val ? new Date(val).pattern("yyyy-MM-dd HH:mm:ss") : '-';
            return date;
          }
          return val;
      },
      handleSelectionChange(val) {
          this.$parent.selectList = val

      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
    },
    watch: {
      tableData(val){
        this.datas = val
      },
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SmartTable.vue